/**
 * Caching configuration for the account users' PK_User → UUID mapping.
 *
 * The mapping is immutable per user (legacy_id_mapping is a write-once lookup), so we never expire
 * entries for staleness. Instead we evict whole account buckets by last-access time (retention) and
 * cap how many accounts we keep (LRU). See `helpers/cacheUtils` and `api/accountApi`.
 */

import { MS_IN_DAY } from '../time';

/**
 * Prefix for our IndexedDB bucket keys. Buckets are scoped by environment + PK_Account (built by
 * `buildAccountUsersCacheKey`); the shared prefix lets retention/LRU eviction recognise them all.
 */
export const ACCOUNT_USERS_CACHE_PREFIX = 'account-users-uuid:';

/** Drop a bucket not accessed within this window (retention, not freshness). */
export const ACCOUNT_USERS_RETENTION_MS = 180 * MS_IN_DAY; // ~6 months

/** Hard cap on stored account buckets; least-recently-accessed beyond this are evicted. */
export const MAX_CACHED_ACCOUNTS = 50;

/** legacy_id_mapping returns at most 200 ids per request; we chunk PK_User lists by this size. */
export const UUID_BATCH_SIZE = 200;
